import { useState, useContext } from "react";
import { PaystackButton } from "react-paystack";
import { FaTimes } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import Toast from "../components/Toast";
import { AuthContext } from "../context/AuthContext";
import "../styles/virtual.css"; // Reuse styles to match PalmPay look

const PaystackPayment = () => {
  const [amount, setAmount] = useState("");
  const { currentUser, addFunds, fetchCurrentUser } = useContext(AuthContext);
  const navigate = useNavigate();

  const publicKey = "pk_live_31cd29b268c730faba3d39cc96d2fccace773139";
  const [toastMessage, setToastMessage] = useState("");
  const [toastType, setToastType] = useState("info");

  const showToast = (message, type = "info") => {
    setToastMessage(message);
    setToastType(type);
  };

  const handleSuccess = async (response) => {
    const result = await addFunds(amount, response.reference);
    if (result?.error) {
      showToast(result.error, "error");
    } else {
      showToast("Funds added successfully!", "success");
      navigate("/dashboard");
    }
  };

  return (
    <div className="pay-virtual-payment-container">
      {toastMessage && (
        <Toast
          message={toastMessage}
          type={toastType}
          onClose={() => setToastMessage("")}
        />
      )}

      <div className="select-virtual-card">

        <h6 className="virtual-header">Pay with Card, Bank Transfer or USSD</h6>
        <p className="virtual-description">
          Fund your wallet instantly using Paystack. <br />
          <strong>Note:</strong> A <strong>5% charge</strong> applies to each transaction.
        </p>

        <div className="pay-virtual-card">
          <div className="pay-virtual-row">
            <span className="pay-virtual-label">ENTER AMOUNT</span>
            <input
              type="number"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              placeholder="e.g. 5000"
              className="virtual-input"
              min="100"
            />
          </div>

          <div className="pay-virtual-row">
            <span className="pay-virtual-label">CHARGE</span>
            <p className="pay-virtual-value">
              ₦{(Number(amount) * 0.050).toLocaleString(undefined, { maximumFractionDigits: 2 })} (5%)
            </p>
          </div>

          <PaystackButton
            className="wallet-btn pay-now"
            publicKey={publicKey}
            email={currentUser?.email}
            amount={amount * 100}
            channels={["card", "bank", "ussd", "bank_transfer"]}
            currency="NGN"
            onSuccess={handleSuccess}
            onClose={() => navigate(-1)}
          >
            Pay Now
          </PaystackButton>
        </div>
      </div>
    </div>
  );
};

export default PaystackPayment;
